import Pipeline from 'types/pipeline';

import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';
import { usePlanIncludedNodes } from 'hooks/usePlanIncludedNodes';

/**
 * Check if the pipeline does not contain nodes from a higher plan
 */
export function useCanDeployPipeline(pipeline?: Pipeline | null): {
  canDeploy: boolean;
  nodeTypesNotIncluded: string[];
} {
  const { data: currentPlan } = useCurrentPlan();
  const [includedNodes] = usePlanIncludedNodes();

  if (
    !pipeline ||
    // Users shouldn't be able to quickly click the deploy button while loading
    currentPlan === undefined
  ) {
    return { canDeploy: false, nodeTypesNotIncluded: [] };
  }

  // If we don't have the included nodes list yet, don't allow deployment
  if (!includedNodes) {
    return { canDeploy: false, nodeTypesNotIncluded: [] };
  }

  const pipelineNodes = pipeline.nodes
    .map(({ component }) => component?.exportType)
    .filter(Boolean) as string[];

  // Check if all pipeline nodes are included in the current plan
  const nodeNamesNotIncluded = pipelineNodes.filter((exportType) => {
    return !includedNodes.has(exportType);
  });

  return {
    canDeploy: nodeNamesNotIncluded.length === 0,
    nodeTypesNotIncluded: nodeNamesNotIncluded,
  };
}
